import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'underscore';
import { statusConfig } from '../config/status-config';

export const MultiSelectedItemComponent = (props) => {
  const { item, hideStatus } = props;
  const renderItemContent = () => (
    <div className="item-content">
      {
        !hideStatus &&
          <span className={classnames('statusIcon', _.result(statusConfig, item.status, 'statusEnabled_icon'))} />
      }
      <span className="text" title={item.name}>
        {item.name}
      </span>
    </div>
  );

  return (
    <div className="multi-item-container">
      <span className={classnames('arrow-button', 'remove', 'a11y-k-listview-button', 'remove-arrow-button')} />
      {
          renderItemContent()
      }
    </div>
  );
};

MultiSelectedItemComponent.propTypes = {
  item: PropTypes.shape({
    status: PropTypes.string,
    name: PropTypes.string.isRequired,
    Id: PropTypes.number.isRequired,
  }).isRequired,
  hideStatus: PropTypes.bool,
};

MultiSelectedItemComponent.defaultProps = {
  hideStatus: false,
};

